/**
 * Benchmark config metadata comparison section.
 *
 * @module config-comparison/BenchmarkConfigDiffSection
 */
import React from 'react';
import { Text } from '@chatsdet/ui';
import type { EnvironmentSnapshot } from '@chatsdet/types';
import { DiffTable } from './DiffTable';
import { diffSnapshots } from './diff-utils';

interface BenchmarkConfigDiffSectionProps {
  configA: EnvironmentSnapshot['benchmarkConfig'] | undefined;
  configB: EnvironmentSnapshot['benchmarkConfig'] | undefined;
  labelA: string;
  labelB: string;
}

export function BenchmarkConfigDiffSection({ configA, configB, labelA, labelB }: BenchmarkConfigDiffSectionProps) {
  const rows = React.useMemo(() => {
    // Flatten jobConfig into top-level keys for readable diffing
    const flatten = (cfg: EnvironmentSnapshot['benchmarkConfig'] | undefined) => {
      if (!cfg) return {};
      const { jobConfig, ...rest } = cfg;
      const flat: Record<string, unknown> = { ...rest };
      if (jobConfig) {
        for (const [k, v] of Object.entries(jobConfig)) {
          flat[`jobConfig.${k}`] = v;
        }
      }
      return flat;
    };
    return diffSnapshots(flatten(configA), flatten(configB));
  }, [configA, configB]);

  return (
    <div>
      <Text weight="medium" className="mb-2">Benchmark Config</Text>
      <DiffTable rows={rows} labelA={labelA} labelB={labelB} />
    </div>
  );
}
